import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface StationTableProps {
  rows: {
    id: string
    description: string
    controller: string
    decoder: string
    address: string
    index: string
    type: string
    configure: string
    priority: string
    gps_coordinates: string
    station_group: string
    pipe: string
    soil: string
    water_required: string
    surface_accumulation: string
    plant: string
    precipitation_rate: string
    expected_flow: string
    landscape_factor: string
    program: string
    plant_group: string
    precip: string
    efficiency: string
    manual: string
    et_node: string
  }[]
}

const StationTable: FC<StationTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '29px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                ID
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Decoder
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Decoder Type
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Address
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Index
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Type
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Configure
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Priority
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                GPS Coordinates
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '77px',
                }}
              >
                StationGroup
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '103px',
                }}
              >
                Pipe
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '82px',
                }}
              >
                Soil
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Water Required
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Surface Accumulation
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Plant Avail Water
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Precipitation Rate
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Expected Flow
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Landscape factor %
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Program
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Plant Group
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '137.53px',
                }}
              >
                Precip (mm/hr)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '96px',
                }}
              >
                Efficiency (%)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '160px',
                }}
              >
                Manual Op Run time (min)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '83px',
                }}
              >
                ET Node
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.controller}</TableCell>
                <TableCell>{row.decoder}</TableCell>
                <TableCell>{row.address}</TableCell>
                <TableCell>{row.index}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.configure}</TableCell>
                <TableCell>{row.priority}</TableCell>
                <TableCell>{row.gps_coordinates}</TableCell>
                <TableCell>{row.station_group}</TableCell>
                <TableCell>{row.pipe}</TableCell>
                <TableCell>{row.soil}</TableCell>
                <TableCell>{row.water_required}</TableCell>
                <TableCell>{row.surface_accumulation}</TableCell>
                <TableCell>{row.plant}</TableCell>
                <TableCell>{row.precipitation_rate}</TableCell>
                <TableCell>{row.expected_flow}</TableCell>
                <TableCell>{row.landscape_factor}</TableCell>
                <TableCell>{row.program}</TableCell>
                <TableCell>{row.plant_group}</TableCell>
                <TableCell>{row.precip}</TableCell>
                <TableCell>{row.efficiency}</TableCell>
                <TableCell>{row.manual}</TableCell>
                <TableCell>{row.et_node}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default StationTable
